import { blogListResultsPerPageStyles as styles } from "@solveindustrial/Widgets/VerndaleBox/BlogCategory/BlogCategoryListResultsPerPageWidget";
import { css } from "styled-components";

styles.selectPerPage = {
    ...styles.selectPerPage,
    labelProps: {
        size: 16,
        css: css`
            width: auto;
            padding: 0 10px 0 0;
        `,
    },

    cssOverrides: {
        ...styles.selectPerPage?.cssOverrides,
        inputSelect: css`
            ${styles.selectPerPage?.cssOverrides?.inputSelect}
            width: auto;
            height: 30px;
            border-radius: 4px;
        `,

        formInputWrapper: css`
            ${styles.selectPerPage?.cssOverrides?.formInputWrapper}
            span {
                width: 34px !important;
                height: 30px !important;
            }
        `,
    },
};
